import { ListOrgUnitUsers } from 'domain/usecases/orgUnit/remote/ListOrgUnitUsers';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteListOrgUnitUsers implements ListOrgUnitUsers {
  private readonly url: string;

  private readonly httpClient: HttpClient<ListOrgUnitUsers.Model>;

  constructor(url: string, httClient: HttpClient<ListOrgUnitUsers.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  list = async (
    params: ListOrgUnitUsers.Params,
  ): Promise<ListOrgUnitUsers.Model> => {
    let query = '';
    Object.entries(params).forEach(([key, value]) => {
      query += `${key}=${value}&`;
    });

    const httpResponse = await this.httpClient.request({
      url: this.url
        .replace('{orgId}', `${params.orgId}`)
        .replace('{unitId}', `${params.unitId}`),
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
      case HttpStatusCode.notModified:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
